<template>
  <img :src="pp ? pp : 'resources/images/avatars/avatar-2.png'" />
</template>

<script>
export default {
  name: "crew-icon",
  props: {
    pp: {},
    name: {
      type: String
    }
  },
  computed: {
    initialName() {
      if (this.name) {
        let arr = this.name.split(" ");
        return `${arr[0][0]}${arr[1] ? arr[1][0] : ""}`;
      }
      return "";
    }
  }
};
</script>
